export enum SignStatusPermissions {
  SignupStatus = 'signup-status',
}
